import React from 'react';
import AuthorParcelsTable from './authorParcelsTable';
import CarrierParcelsTable from './carrierParcelsTable.jsx';
import { getRoles } from '../../../services/userRights';

export default class ParcelsTable extends React.Component {
    render() {
        let isCarrier = getRoles().includes('Carrier');
        return isCarrier 
			? <CarrierParcelsTable history={this.props.history} /> 
			: <AuthorParcelsTable history={this.props.history} />;
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/table/parcelsTable.jsx